import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { AuxiaResponse } from './get-auxia-jsm-paid-lp-treatment';

function isValidAuxiaResponse(
	auxiaResponse: AuxiaResponse | null | undefined,
): auxiaResponse is AuxiaResponse {
	return (
		auxiaResponse !== null &&
		auxiaResponse !== undefined &&
		typeof auxiaResponse.treatmentId === 'string' &&
		typeof auxiaResponse.treatmentTrackingId === 'string' &&
		auxiaResponse.treatmentId.length > 0 &&
		auxiaResponse.treatmentTrackingId.length > 0 &&
		Array.isArray(auxiaResponse.auxiaTreatment) &&
		auxiaResponse.auxiaTreatment.length > 0
	);
}

export const isAuxiaServedPage = (
	auxiaResponse: AuxiaResponse | null | undefined,
): auxiaResponse is AuxiaResponse => {
	const usingAuxiaTreatment = checkFeatureFlagGate(featureFlags.jsmPaidLpAuxiaIntegration);

	return usingAuxiaTreatment && isValidAuxiaResponse(auxiaResponse);
};

export const isAuxiaResponseMalformed = (
	auxiaResponse: AuxiaResponse | null | undefined,
): auxiaResponse is AuxiaResponse => {
	const usingAuxiaTreatment = checkFeatureFlagGate(featureFlags.jsmPaidLpAuxiaIntegration);

	return usingAuxiaTreatment && !isValidAuxiaResponse(auxiaResponse);
};
